let eventList = [];
module.exports = {
  on(eventName, callback){
    eventList.push({eventName, callback});
    return this;
  },
  off(eventName, callback){
    eventList = eventList.filter(item => {
      if (item.eventName === eventName) {
        if (!callback || (callback && callback === item.callback)) {
          return false;
        }
      }
      return true;
    });
    return this;
  },
  trigger(eventName, props){
    eventList.forEach(item => {
      if (item.eventName === eventName) {
        item.callback(props);
      }
    });
    return this;
  }
};